import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** house, home. Decorative line icon; always pair with a visible text label. */
export function HomeIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 10.5L12 3.5l8 7" />
      <path d="M6 9.8V20a.5.5 0 0 0 .5.5h11A.5.5 0 0 0 18 20V9.8" />
      <path d="M10 20.5v-5.5h4v5.5" />
    </IconSvg>
  )
}
